(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const SOKSI_COLLECTION_VIEW_PARAM = 'soksi_collection_view';
  const SOKSI_COLLECTION_VIEW_LEGACY_PARAM = 'type';
  const SOKSI_COLLECTION_VIEW_VALUES = new Set(['view-all', 'new-arrivals', 'essentials']);
  const SOKSI_COLOR_FAMILY_ORDER = [
    'black',
    'white',
    'grey',
    'beige',
    'brown',
    'red',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'pink',
    'other',
  ];

  const soksiColorFamilyLabelsNode = document.querySelector('[data-soksi-color-family-labels]');
  const SOKSI_COLOR_FAMILY_LABELS = (() => {
    if (!soksiColorFamilyLabelsNode) return {};

    try {
      return JSON.parse(soksiColorFamilyLabelsNode.getAttribute('data-soksi-color-family-labels') || '{}');
    } catch (error) {
      return {};
    }
  })();

  const SOKSI_COLOR_FAMILY_KEYWORDS = {
    black: ['black', 'nero', 'noir', 'ebony', 'ebano', 'dark'],
    white: ['white', 'bianco', 'blanc', 'ivory', 'milk'],
    grey: ['grey', 'gray', 'grigio', 'gris', 'silver', 'argento'],
    beige: ['beige', 'nude', 'natural', 'naturel', 'ecru', 'cream', 'glace', 'cocoon'],
    brown: ['brown', 'marron', 'marrone', 'coffee', 'caffe', 'cocoa', 'taupe', 'cognac', 'bronze', 'cuivre'],
    red: ['red', 'rosso', 'rouge', 'scarlet', 'cherry', 'barolo', 'bordeaux', 'hibiscus', 'lipstick', 'geranio'],
    orange: ['orange', 'arancio', 'ochre', 'ocra', 'amber'],
    yellow: ['yellow', 'giallo', 'jaune', 'gold', 'oro', 'fluo'],
    green: ['green', 'verde', 'vert', 'forest', 'forrest', 'hunter', 'lime'],
    blue: ['blue', 'blu', 'navy', 'denim', 'jeans', 'cobalt', 'electric', 'turquoise', 'teal', 'aqua', 'azur'],
    purple: ['purple', 'violet', 'viola', 'lavender', 'lilac', 'plum', 'glycine'],
    pink: ['pink', 'rosa', 'rose', 'fuchsia', 'magenta', 'azalea', 'cyclamen'],
  };

  const SOKSI_HEX_PATTERN = /#[0-9a-f]{6}/gi;
  const SOKSI_COLOR_GROUPS_STORAGE_PREFIX = 'soksi-color-groups:';
  const SOKSI_COLOR_GROUPS_STORAGE_TTL_MS = 1000 * 60 * 60 * 6;
  const SOKSI_COLLECTION_PANEL_STATE_STORAGE_PREFIX = 'soksi-collection-panel-state:';
  const SOKSI_COLLECTION_VIEW_MIN_VISIBLE_MATCHES = 1;
  const SOKSI_COLOR_HEX_FAMILY_OVERRIDES = {
    // Example overrides:
    // '#C47A3A': 'orange',
    // '#B6895B': 'beige',
  };

  let soksiCollectionViewEnsurePromise = null;

  const normalizeText = (value = '') =>
    value
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const extractHexes = (value = '') => {
    const matches = value.match(SOKSI_HEX_PATTERN);
    if (!matches) return [];
    return [...new Set(matches.map((match) => match.toUpperCase()))];
  };

  const hexToRgb = (hex) => {
    const normalized = hex.replace('#', '').trim();
    if (normalized.length !== 6) return null;

    const parsed = Number.parseInt(normalized, 16);
    if (Number.isNaN(parsed)) return null;

    return {
      r: (parsed >> 16) & 255,
      g: (parsed >> 8) & 255,
      b: parsed & 255,
    };
  };

  const rgbToHsl = (r, g, b) => {
    const red = r / 255;
    const green = g / 255;
    const blue = b / 255;

    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const delta = max - min;

    let hue = 0;
    if (delta !== 0) {
      switch (max) {
        case red:
          hue = ((green - blue) / delta + (green < blue ? 6 : 0)) * 60;
          break;
        case green:
          hue = ((blue - red) / delta + 2) * 60;
          break;
        default:
          hue = ((red - green) / delta + 4) * 60;
          break;
      }
    }

    const lightness = (max + min) / 2;
    const saturation =
      delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));

    return { h: hue, s: saturation, l: lightness };
  };

  const classifyColorFamily = (hex) => {
    const normalizedHex = `#${hex.toString().replace('#', '').trim().toUpperCase()}`;
    const overriddenFamily = SOKSI_COLOR_HEX_FAMILY_OVERRIDES[normalizedHex];
    if (overriddenFamily) return overriddenFamily;

    const rgb = hexToRgb(normalizedHex);
    if (!rgb) return 'other';

    const { h, s, l } = rgbToHsl(rgb.r, rgb.g, rgb.b);
    const isHueBetween = (start, end) =>
      start <= end
        ? h >= start && h < end
        : h >= start || h < end;

    // 1) Achromatic / near-achromatic
    if (s <= 0.1) {
      if (l <= 0.15) return 'black';
      if (l >= 0.9) return 'white';
      return 'grey';
    }

    // 2) Warm low-saturation colors
    if (isHueBetween(25, 70) && s <= 0.35 && l >= 0.6 && l < 0.9) {
      return 'beige';
    }
    if (isHueBetween(15, 45) && s >= 0.18 && l <= 0.5) {
      return 'brown';
    }

    // 3) General hue families
    if (isHueBetween(345, 15)) return 'red';
    if (isHueBetween(15, 40)) return 'orange';
    if (isHueBetween(40, 70)) return 'yellow';
    if (isHueBetween(70, 170)) return 'green';
    if (isHueBetween(170, 255)) return 'blue';
    if (isHueBetween(255, 320)) return l > 0.63 ? 'pink' : 'purple';
    if (isHueBetween(320, 345)) return 'pink';

    return 'other';
  };

  const sortGroups = (a, b) => {
    const aIndex = SOKSI_COLOR_FAMILY_ORDER.indexOf(a.id);
    const bIndex = SOKSI_COLOR_FAMILY_ORDER.indexOf(b.id);

    const normalizedA = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
    const normalizedB = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;

    if (normalizedA !== normalizedB) return normalizedA - normalizedB;
    if (a.count !== b.count) return b.count - a.count;

    return a.label.localeCompare(b.label);
  };

  const normalizeFacetValue = (value = '') =>
    value
      .toString()
      .trim()
      .toLowerCase();

  const parseSelectedColorFamilies = (rawValue = '') =>
    new Set(
      rawValue
        .split(',')
        .map((value) => normalizeFacetValue(value))
        .filter(Boolean)
    );

  const serializeSelectedColorFamilies = (families) =>
    Array.from(families)
      .filter(Boolean)
      .sort(sortFamilyIds)
      .join(',');

  const hasSetIntersection = (left, right) => {
    for (const value of left) {
      if (right.has(value)) return true;
    }
    return false;
  };

  const sortFamilyIds = (leftId, rightId) => {
    const leftIndex = SOKSI_COLOR_FAMILY_ORDER.indexOf(leftId);
    const rightIndex = SOKSI_COLOR_FAMILY_ORDER.indexOf(rightId);
    const normalizedLeft = leftIndex === -1 ? Number.MAX_SAFE_INTEGER : leftIndex;
    const normalizedRight = rightIndex === -1 ? Number.MAX_SAFE_INTEGER : rightIndex;
    return normalizedLeft - normalizedRight;
  };

  const getColorFamilyLabelsFromHexes = (hexes = []) => {
    const families = [...new Set(hexes.map((hex) => classifyColorFamily(hex)))];

    return families
      .sort(sortFamilyIds)
      .map((familyId) => SOKSI_COLOR_FAMILY_LABELS[familyId] ?? familyId);
  };

  const formatNativeColorLabel = (rawLabel = '') => {
    const normalizedLabel = rawLabel.toString().replace(/\s+/g, ' ').trim();
    if (!normalizedLabel) return '';

    const hexes = extractHexes(normalizedLabel);
    if (hexes.length === 0) return normalizedLabel;

    const familyLabels = getColorFamilyLabelsFromHexes(hexes);
    if (familyLabels.length === 0) return normalizedLabel;

    const prefix = normalizedLabel.split('#')[0].replace(/[;,\s]+$/g, '').trim();
    const compactLabel = familyLabels.join(' + ');

    return prefix ? `${prefix} ${compactLabel}` : compactLabel;
  };

  const getCollectionColorStorageKey = () =>
    `${SOKSI_COLOR_GROUPS_STORAGE_PREFIX}${window.location.pathname}`;

  const getCollectionPanelStateStorageKey = () =>
    `${SOKSI_COLLECTION_PANEL_STATE_STORAGE_PREFIX}${window.location.pathname}`;

  const readCollectionPanelState = () => {
    try {
      const rawPayload = sessionStorage.getItem(getCollectionPanelStateStorageKey());
      if (!rawPayload) return {};

      const parsed = JSON.parse(rawPayload);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  };

  const persistCollectionPanelOpenState = (panelId, isOpen) => {
    if (!panelId) return;

    try {
      const currentState = readCollectionPanelState();
      currentState[panelId] = Boolean(isOpen);
      sessionStorage.setItem(getCollectionPanelStateStorageKey(), JSON.stringify(currentState));
    } catch {
      // Ignore storage errors to avoid blocking filtering interactions.
    }
  };

  const getCollectionPanelId = (panel) => {
    if (!(panel instanceof HTMLElement)) return '';
    if (panel.classList.contains('soksi-collection-rail__panel--colors')) return 'colors';
    if (panel.classList.contains('soksi-collection-rail__panel--sort')) return 'sort';
    return '';
  };

  const initializeCollectionPanelStatePersistence = (root = document) => {
    const storedState = readCollectionPanelState();

    root.querySelectorAll('.soksi-collection-rail__panel').forEach((panel) => {
      if (!(panel instanceof HTMLDetailsElement)) return;

      const panelId = getCollectionPanelId(panel);
      if (!panelId) return;

      if (typeof storedState[panelId] === 'boolean') {
        panel.open = storedState[panelId];
      }

      if (panel.dataset.soksiPanelStateBound === 'true') return;
      panel.dataset.soksiPanelStateBound = 'true';

      panel.addEventListener('toggle', () => {
        persistCollectionPanelOpenState(panelId, panel.open);
      });
    });
  };

  const isGroupActive = (groupId, normalizedValues, selectedValues, selectedFamilies) => {
    if (selectedFamilies.size > 0) {
      return selectedFamilies.has(groupId);
    }

    if (selectedValues.size > 0) {
      return hasSetIntersection(selectedValues, normalizedValues);
    }

    return false;
  };

  const persistServerColorGroups = (paramName, groups) => {
    if (!paramName || !Array.isArray(groups) || groups.length === 0) return;

    const serializedGroups = groups
      .map((group) => ({
        id: group.id,
        label: group.label,
        count: group.count,
        comboValues: Array.isArray(group.comboValues) ? group.comboValues : [],
        hexes: Array.isArray(group.hexes) ? group.hexes : [],
      }))
      .filter((group) => group.comboValues.length > 0);

    if (serializedGroups.length === 0) return;

    try {
      sessionStorage.setItem(
        getCollectionColorStorageKey(),
        JSON.stringify({
          savedAt: Date.now(),
          paramName,
          groups: serializedGroups,
        })
      );
    } catch {
      // Ignore storage errors to avoid blocking collection interactions.
    }
  };

  const readPersistedServerColorGroups = (paramName, selectedValues = new Set(), selectedFamilies = new Set()) => {
    if (!paramName) return [];

    try {
      const rawPayload = sessionStorage.getItem(getCollectionColorStorageKey());
      if (!rawPayload) return [];

      const payload = JSON.parse(rawPayload);
      if (!payload || payload.paramName !== paramName || !Array.isArray(payload.groups)) return [];

      const savedAt = Number(payload.savedAt ?? 0);
      if (savedAt > 0 && Date.now() - savedAt > SOKSI_COLOR_GROUPS_STORAGE_TTL_MS) {
        sessionStorage.removeItem(getCollectionColorStorageKey());
        return [];
      }

      return payload.groups
        .map((group) => {
          const comboValues = Array.isArray(group.comboValues)
            ? group.comboValues.map((value) => value.toString())
            : [];
          const normalizedValues = new Set(
            comboValues.map((value) => normalizeFacetValue(value)).filter(Boolean)
          );

          return {
            id: group.id,
            label: group.label,
            count: Number.parseInt(group.count, 10) || 0,
            comboValues,
            hexes: Array.isArray(group.hexes) ? group.hexes : [],
            active: isGroupActive(group.id, normalizedValues, selectedValues, selectedFamilies),
            mode: 'server',
          };
        })
        .filter((group) => group.comboValues.length > 0)
        .sort(sortGroups);
    } catch {
      return [];
    }
  };

  const normalizeCollectionQueryParams = () => {
    const url = new URL(window.location.href);
    let didChange = false;

    ['sort_by', 'soksi_color', SOKSI_COLLECTION_VIEW_PARAM].forEach((paramName) => {
      const values = url.searchParams.getAll(paramName).filter((value) => value !== '');
      if (values.length <= 1) return;

      const keptValue = values[values.length - 1];
      url.searchParams.delete(paramName);
      url.searchParams.set(paramName, keptValue);
      didChange = true;
    });

    if (didChange) {
      history.replaceState({}, '', url.toString());
    }
  };

  const isNativeHexColorParam = (paramName = '') => {
    const normalized = paramName.toLowerCase();
    return normalized.includes('custom.color_hex') || normalized.includes('custom.colour_hex');
  };

  const getInputLabelElement = (input) => {
    if (!(input instanceof HTMLInputElement) || !input.id) return null;
    const escapedId = window.CSS?.escape ? window.CSS.escape(input.id) : input.id;
    return document.querySelector(`label[for="${escapedId}"]`);
  };

  const getLabelTextElement = (labelElement) => {
    if (!(labelElement instanceof HTMLElement)) return null;

    const nestedLabel =
      labelElement.querySelector('.checkbox__label-text')
      || labelElement.querySelector('.facets__swatch-label')
      || labelElement.querySelector('.facets__image-label')
      || labelElement.querySelector('.facets__pill-label');

    if (nestedLabel instanceof HTMLElement) return nestedLabel;

    if (
      labelElement.matches('.facets__swatch-label')
      || labelElement.matches('.facets__image-label')
      || labelElement.matches('.facets__pill-label')
    ) {
      return labelElement;
    }

    return null;
  };

  const sanitizeNativeColorFacetLabels = () => {
    const colorInputs = Array.from(
      document.querySelectorAll('input[type="checkbox"][name]')
    ).filter(
      (node) => node instanceof HTMLInputElement && isNativeHexColorParam(node.name)
    );

    colorInputs.forEach((input) => {
      const labelElement = getInputLabelElement(input);
      const labelTextElement = getLabelTextElement(labelElement);
      if (!(labelTextElement instanceof HTMLElement)) return;

      const rawLabel =
        input.dataset.soksiRawLabel
        || input.dataset.label
        || labelTextElement.textContent
        || input.value
        || '';

      const normalizedRawLabel = rawLabel.replace(/\s+/g, ' ').trim();
      if (!normalizedRawLabel) return;

      input.dataset.soksiRawLabel = normalizedRawLabel;
      if (!labelElement?.hasAttribute('title')) {
        labelElement?.setAttribute('title', normalizedRawLabel);
      }

      const compactLabel = formatNativeColorLabel(normalizedRawLabel);
      if (!compactLabel) return;

      labelTextElement.textContent = compactLabel;
      input.dataset.label = compactLabel;
    });

    document.querySelectorAll('.facets-remove__pill').forEach((pill) => {
      if (!(pill instanceof HTMLElement)) return;

      const textNode = Array.from(pill.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent?.trim()
      );
      if (!(textNode instanceof Text)) return;

      const rawPillText = (
        pill.dataset.soksiRawLabel
        || textNode.textContent
        || ''
      )
        .replace(/\s+/g, ' ')
        .trim();

      const withoutTrailingRemove = rawPillText.replace(/\s+remove$/i, '').trim();
      if (!withoutTrailingRemove.includes('#')) return;

      pill.dataset.soksiRawLabel = rawPillText;
      if (!pill.hasAttribute('title')) {
        pill.setAttribute('title', withoutTrailingRemove);
      }

      const compactLabel = formatNativeColorLabel(withoutTrailingRemove);
      if (!compactLabel) return;

      textNode.textContent = ` ${compactLabel} `;
    });
  };

  const createGroupsFromEntries = (entries, selectedValues = new Set(), selectedFamilies = new Set()) => {
    const hasHexBasedData = entries.some((entry) => entry.hexes.length > 0);

    if (!hasHexBasedData) {
      return entries.map((entry, index) => ({
        id: `value-${index}`,
        label: entry.label,
        count: entry.count,
        active: isGroupActive(
          `value-${index}`,
          new Set([normalizeFacetValue(entry.value)]),
          selectedValues,
          selectedFamilies
        ),
        comboValues: [entry.value],
        hexes: [],
        mode: 'server',
      }));
    }

    const groupsMap = new Map();

    entries.forEach((entry) => {
      if (entry.hexes.length === 0) return;

      const familiesInEntry = new Set();
      entry.hexes.forEach((hex) => {
        const familyId = classifyColorFamily(hex);
        familiesInEntry.add(familyId);

        if (!groupsMap.has(familyId)) {
          groupsMap.set(familyId, {
            id: familyId,
            label: SOKSI_COLOR_FAMILY_LABELS[familyId] ?? familyId,
            count: 0,
            active: false,
            comboValues: new Set(),
            hexes: new Set(),
          });
        }

        groupsMap.get(familyId)?.hexes.add(hex);
      });

      familiesInEntry.forEach((familyId) => {
        const group = groupsMap.get(familyId);
        if (!group) return;

        group.count += entry.count;
        group.comboValues.add(entry.value);
      });
    });

    return Array.from(groupsMap.values())
      .map((group) => ({
        ...group,
        comboValues: Array.from(group.comboValues),
        hexes: Array.from(group.hexes),
        active: isGroupActive(
          group.id,
          new Set(Array.from(group.comboValues).map((value) => normalizeFacetValue(value)).filter(Boolean)),
          selectedValues,
          selectedFamilies
        ),
        mode: 'server',
      }))
      .sort(sortGroups);
  };

  const extractColorFamiliesFromText = (value = '') => {
    const normalized = ` ${normalizeText(value)} `;
    const families = new Set();

    Object.entries(SOKSI_COLOR_FAMILY_KEYWORDS).forEach(([family, keywords]) => {
      const hasMatch = keywords.some((keyword) => normalized.includes(` ${keyword} `));
      if (hasMatch) {
        families.add(family);
      }
    });

    if (families.size === 0) {
      families.add('other');
    }

    return Array.from(families);
  };

  const getProductTitleFromCard = (card) => {
    const titleLink = Array.from(card.querySelectorAll('a[href*="/products/"]')).find((link) => {
      const text = link.textContent.replace(/\s+/g, ' ').trim();
      return text.length > 3 && !/^€/.test(text);
    });

    if (titleLink) {
      return titleLink.textContent.replace(/\s+/g, ' ').trim();
    }

    const imageWithAlt = card.querySelector('img[alt]');
    if (imageWithAlt instanceof HTMLImageElement) {
      return imageWithAlt.alt.replace(/\s+/g, ' ').trim();
    }

    return '';
  };

  const getProductHandleFromCard = (card) => {
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!(productLink instanceof HTMLAnchorElement)) return '';

    try {
      const productUrl = new URL(productLink.href, window.location.origin);
      const segments = productUrl.pathname.split('/').filter(Boolean);
      return segments[segments.length - 1] ?? '';
    } catch {
      return '';
    }
  };

  const getFallbackColorGroups = () => {
    const cards = Array.from(document.querySelectorAll('.product-grid__item'));
    const groupsMap = new Map();
    const selectedFamilies = parseSelectedColorFamilies(
      new URL(window.location.href).searchParams.get('soksi_color') ?? ''
    );

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      const title = getProductTitleFromCard(card);
      const handle = getProductHandleFromCard(card);
      const source = `${title} ${handle.replace(/-/g, ' ')}`.trim();
      const families = extractColorFamiliesFromText(source);

      card.dataset.soksiColorFamilies = families.join(',');

      families.forEach((familyId) => {
        if (!groupsMap.has(familyId)) {
          groupsMap.set(familyId, {
            id: familyId,
            label: SOKSI_COLOR_FAMILY_LABELS[familyId] ?? familyId,
            count: 0,
            active: selectedFamilies.has(familyId),
            comboValues: [],
            hexes: [],
            mode: 'client',
          });
        }

        const group = groupsMap.get(familyId);
        if (!group) return;
        group.count += 1;
      });
    });

    return Array.from(groupsMap.values())
      .filter((group) => group.count > 0)
      .sort(sortGroups);
  };

  const applyClientColorFilter = (familyId = '') => {
    const url = new URL(window.location.href);
    const selectedFamilies = parseSelectedColorFamilies(url.searchParams.get('soksi_color') ?? '');

    if (selectedFamilies.has(familyId)) {
      selectedFamilies.delete(familyId);
    } else if (familyId) {
      selectedFamilies.add(familyId);
    }

    const serializedFamilies = serializeSelectedColorFamilies(selectedFamilies);
    url.searchParams.delete('page');

    if (serializedFamilies) {
      url.searchParams.set('soksi_color', serializedFamilies);
    } else {
      url.searchParams.delete('soksi_color');
    }

    persistCollectionPanelOpenState('colors', true);
    history.replaceState({}, '', url.toString());
    initializeColorPanels(document);
  };

  const resetClientColorVisibility = () => {
    const cards = Array.from(document.querySelectorAll('.product-grid__item'));

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;
      if (card.dataset.soksiClientColorHidden !== 'true') return;

      delete card.dataset.soksiClientColorHidden;
      updateCollectionCardVisibility(card);
    });
  };

  const updateCollectionCardVisibility = (card) => {
    if (!(card instanceof HTMLElement)) return;

    const shouldHide =
      card.dataset.soksiClientColorHidden === 'true'
      || card.dataset.soksiCollectionViewHidden === 'true';

    card.hidden = shouldHide;
  };

  const applyClientColorVisibility = () => {
    const selectedFamilies = parseSelectedColorFamilies(
      new URL(window.location.href).searchParams.get('soksi_color') ?? ''
    );
    const cards = Array.from(document.querySelectorAll('.product-grid__item'));

    if (selectedFamilies.size === 0) {
      resetClientColorVisibility();
      return;
    }

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      const families = (card.dataset.soksiColorFamilies ?? '').split(',').filter(Boolean);
      const shouldHide = !families.some((family) => selectedFamilies.has(family));

      if (shouldHide) {
        card.dataset.soksiClientColorHidden = 'true';
        updateCollectionCardVisibility(card);
        return;
      }

      if (card.dataset.soksiClientColorHidden === 'true') {
        delete card.dataset.soksiClientColorHidden;
        updateCollectionCardVisibility(card);
      }
    });
  };

  const normalizeCollectionView = (value = '') => {
    const normalizedValue = value.toString().trim().toLowerCase();

    if (normalizedValue === 'new') return 'new-arrivals';
    if (SOKSI_COLLECTION_VIEW_VALUES.has(normalizedValue)) return normalizedValue;
    return '';
  };

  const normalizeCollectionViewHash = (hash = '') => {
    const normalizedHash = hash.toString().trim().toLowerCase().replace(/^#/, '');
    if (!normalizedHash) return '';

    const hashValue = normalizedHash.startsWith('soksi-collection-view=')
      ? normalizedHash.replace('soksi-collection-view=', '')
      : normalizedHash;

    return normalizeCollectionView(hashValue);
  };

  const getRequestedCollectionView = (url = new URL(window.location.href)) => {
    const hashView = normalizeCollectionViewHash(url.hash);
    if (hashView) return hashView;

    const primaryView = normalizeCollectionView(url.searchParams.get(SOKSI_COLLECTION_VIEW_PARAM) ?? '');
    if (primaryView) return primaryView;

    return normalizeCollectionView(url.searchParams.get(SOKSI_COLLECTION_VIEW_LEGACY_PARAM) ?? '');
  };

  const getServerCollectionView = (root = document) => {
    const resultsList = root.querySelector('[data-soksi-server-collection-view]');
    if (!(resultsList instanceof HTMLElement)) return '';
    return normalizeCollectionView(resultsList.dataset.soksiServerCollectionView ?? '');
  };

  const getAvailableCollectionViews = (root = document) =>
    new Set(
      Array.from(root.querySelectorAll('[data-soksi-collection-view-button]'))
        .map((button) => button.dataset.soksiCollectionView ?? '')
        .filter((value) => SOKSI_COLLECTION_VIEW_VALUES.has(value))
    );

  const getActiveCollectionView = (root = document) => {
    const url = new URL(window.location.href);
    const requestedView = getRequestedCollectionView(url) || getServerCollectionView(root);
    const availableViews = getAvailableCollectionViews(root);
    availableViews.add('view-all');

    if (!SOKSI_COLLECTION_VIEW_VALUES.has(requestedView)) return 'view-all';
    if (!availableViews.has(requestedView)) return 'view-all';
    return requestedView;
  };

  const isCollectionCardEssential = (card) => card.dataset.soksiIsEssential === 'true';
  const isCollectionCardNewArrival = (card) => card.dataset.soksiIsNew === 'true';
  const getCollectionResultsList = (root = document) => {
    const resultsList = root.querySelector('results-list');
    return resultsList instanceof HTMLElement ? resultsList : null;
  };

  const getCollectionGrid = (root = document) => {
    const resultsList = getCollectionResultsList(root);
    const refsGrid = resultsList?.refs?.grid;
    if (refsGrid instanceof HTMLElement) return refsGrid;

    const fallbackGrid = root.querySelector('[ref="grid"]');
    return fallbackGrid instanceof HTMLElement ? fallbackGrid : null;
  };

  const getCollectionLoadedPageNumbers = (root = document) => {
    const grid = getCollectionGrid(root);
    if (!(grid instanceof HTMLElement)) return [];

    return [...new Set(
      Array.from(grid.querySelectorAll('.product-grid__item'))
        .map((card) => Number.parseInt(card.dataset.page ?? '', 10))
        .filter((page) => Number.isFinite(page) && page > 0)
    )].sort((left, right) => left - right);
  };

  const getCollectionLastPage = (root = document) => {
    const lastPage = Number.parseInt(getCollectionGrid(root)?.dataset.lastPage ?? '1', 10);
    if (!Number.isFinite(lastPage) || lastPage < 1) return 1;
    return lastPage;
  };

  const getNextCollectionPageToLoad = (root = document) => {
    const loadedPages = getCollectionLoadedPageNumbers(root);
    if (loadedPages.length === 0) return 1;

    const nextPage = loadedPages[loadedPages.length - 1] + 1;
    if (nextPage > getCollectionLastPage(root)) return null;

    return nextPage;
  };

  const getCollectionViewMatchCount = (root = document, visibleOnly = false) => {
    const activeView = getActiveCollectionView(root);
    const cards = Array.from(getCollectionGrid(root)?.querySelectorAll('.product-grid__item') ?? []);

    if (activeView === 'view-all') {
      return visibleOnly ? cards.filter((card) => !card.hidden).length : cards.length;
    }

    return cards.filter((card) => {
      if (!(card instanceof HTMLElement)) return false;
      if (visibleOnly && card.hidden) return false;

      if (activeView === 'new-arrivals') return isCollectionCardNewArrival(card);
      if (activeView === 'essentials') return isCollectionCardEssential(card);
      return true;
    }).length;
  };

  const fetchCollectionPageCards = async (root = document, pageNumber) => {
    const resultsList = getCollectionResultsList(root);
    const sectionId = resultsList?.getAttribute('section-id');
    if (!sectionId) return { cards: [], lastPage: '' };

    const url = new URL(window.location.href);
    url.searchParams.delete(SOKSI_COLLECTION_VIEW_PARAM);
    url.searchParams.delete(SOKSI_COLLECTION_VIEW_LEGACY_PARAM);
    url.searchParams.set('page', pageNumber.toString());
    url.searchParams.set('section_id', sectionId.replace(/^shopify-section-/, ''));
    url.hash = '';

    const response = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!response.ok) return { cards: [], lastPage: '' };

    const html = await response.text();
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const parsedGrid = parsedDocument.querySelector('[ref="grid"]');
    if (!(parsedGrid instanceof HTMLElement)) return { cards: [], lastPage: '' };

    return {
      cards: Array.from(parsedGrid.querySelectorAll(':scope > [ref="cards[]"], :scope > .product-grid__item')),
      lastPage: parsedGrid.dataset.lastPage ?? '',
    };
  };

  const appendCollectionPageCards = async (root = document, pageNumber) => {
    const grid = getCollectionGrid(root);
    if (!(grid instanceof HTMLElement)) return 0;

    const existingProductIds = new Set(
      Array.from(grid.querySelectorAll('.product-grid__item'))
        .map((card) => card.dataset.productId ?? '')
        .filter(Boolean)
    );

    const { cards, lastPage } = await fetchCollectionPageCards(root, pageNumber);
    if (lastPage) {
      grid.dataset.lastPage = lastPage;
    }

    if (cards.length === 0) return 0;

    const fragment = document.createDocumentFragment();
    let appendedCount = 0;

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      const productId = card.dataset.productId ?? '';
      if (productId && existingProductIds.has(productId)) return;

      if (productId) {
        existingProductIds.add(productId);
      }

      fragment.appendChild(card.cloneNode(true));
      appendedCount += 1;
    });

    if (appendedCount > 0) {
      grid.appendChild(fragment);
    }

    return appendedCount;
  };

  const ensureActiveCollectionViewHasVisibleResults = (root = document) => {
    if (soksiCollectionViewEnsurePromise) return soksiCollectionViewEnsurePromise;

    soksiCollectionViewEnsurePromise = (async () => {
      const targetView = getActiveCollectionView(root);
      if (targetView === 'view-all') return;

      while (getActiveCollectionView(root) === targetView) {
        const visibleMatches = getCollectionViewMatchCount(root, true);
        if (visibleMatches >= SOKSI_COLLECTION_VIEW_MIN_VISIBLE_MATCHES) break;

        const nextPage = getNextCollectionPageToLoad(root);
        if (!nextPage) break;

        const appendedCount = await appendCollectionPageCards(root, nextPage);
        applyCollectionViewVisibility(root);

        if (appendedCount === 0) break;
      }
    })().finally(() => {
      soksiCollectionViewEnsurePromise = null;
    });

    return soksiCollectionViewEnsurePromise;
  };

  const applyCollectionViewVisibility = (root = document) => {
    const activeView = getActiveCollectionView(root);
    const serverView = getServerCollectionView(root);
    const cards = Array.from(document.querySelectorAll('.product-grid__item'));

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      let shouldHide = false;
      if (activeView === 'new-arrivals') {
        shouldHide = !isCollectionCardNewArrival(card);
      } else if (activeView === 'essentials') {
        shouldHide = !isCollectionCardEssential(card);
      }

      if (shouldHide) {
        card.dataset.soksiCollectionViewHidden = 'true';
      } else {
        delete card.dataset.soksiCollectionViewHidden;
      }

      updateCollectionCardVisibility(card);
    });

    root.querySelectorAll('[data-soksi-collection-view-button]').forEach((button) => {
      if (!(button instanceof HTMLElement)) return;

      const buttonView = button.dataset.soksiCollectionView ?? 'view-all';
      const isActive = buttonView === activeView;
      button.classList.toggle('is-active', isActive);

      if (button instanceof HTMLButtonElement) {
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      } else if (button instanceof HTMLAnchorElement) {
        if (isActive) {
          button.setAttribute('aria-current', 'page');
        } else {
          button.removeAttribute('aria-current');
        }
      }
    });

    const url = new URL(window.location.href);
    const currentHashView = normalizeCollectionViewHash(url.hash);
    const currentParam = normalizeCollectionView(url.searchParams.get(SOKSI_COLLECTION_VIEW_PARAM) ?? '');
    const currentLegacyParam = normalizeCollectionView(url.searchParams.get(SOKSI_COLLECTION_VIEW_LEGACY_PARAM) ?? '');

    if (activeView === 'view-all') {
      if (currentHashView || currentParam || currentLegacyParam) {
        url.searchParams.delete(SOKSI_COLLECTION_VIEW_PARAM);
        url.searchParams.delete(SOKSI_COLLECTION_VIEW_LEGACY_PARAM);
        url.hash = '';
        history.replaceState({}, '', url.toString());
      }
      return;
    }

    if (serverView === activeView && !currentHashView && !currentParam && !currentLegacyParam) {
      return;
    }

    if (currentHashView !== activeView || currentParam || currentLegacyParam) {
      url.searchParams.delete(SOKSI_COLLECTION_VIEW_PARAM);
      url.searchParams.delete(SOKSI_COLLECTION_VIEW_LEGACY_PARAM);
      url.hash = `soksi-collection-view=${activeView}`;
      history.replaceState({}, '', url.toString());
    }
  };

  const initializeCollectionViewButtons = (root = document) => {
    root.querySelectorAll('[data-soksi-collection-view-button]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      if (button.dataset.soksiCollectionViewBound === 'true') return;

      button.dataset.soksiCollectionViewBound = 'true';
      button.addEventListener('click', () => {
        const targetView = button.dataset.soksiCollectionView ?? 'view-all';
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.delete(SOKSI_COLLECTION_VIEW_PARAM);
        url.searchParams.delete(SOKSI_COLLECTION_VIEW_LEGACY_PARAM);

        if (targetView === 'view-all') {
          url.hash = '';
        } else {
          url.hash = `soksi-collection-view=${targetView}`;
        }

        history.replaceState({}, '', url.toString());
        applyCollectionViewVisibility(document);
        void ensureActiveCollectionViewHasVisibleResults(document);
      });
    });
  };

  const applyColorFamilyFilter = (paramName, groups, familyId = '') => {
    if (paramName !== 'filter.p.m.custom.color_families' || !familyId) return;
    const url = new URL(window.location.href);
    const selected = new Set(url.searchParams.getAll(paramName));
    if (selected.has(familyId)) selected.delete(familyId);
    else selected.add(familyId);
    url.searchParams.delete(paramName);
    url.searchParams.delete('page');
    url.searchParams.delete('soksi_color');
    url.searchParams.delete('filter.p.m.custom.color_hex');
    selected.forEach((value) => url.searchParams.append(paramName, value));
    persistCollectionPanelOpenState('colors', true);
    window.location.assign(url.toString());
  };

  const buildGroupElement = (group, paramName, groups, showSwatches = true) => {
    const listItem = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'soksi-collection-rail__option soksi-collection-rail__option--color-group';

    if (group.active) {
      button.classList.add('is-active');
    }

    if (!showSwatches) {
      button.classList.add('soksi-collection-rail__option--color-boxes');
    }

    const marker = document.createElement('span');
    marker.className = 'soksi-collection-rail__option-marker';
    marker.setAttribute('aria-hidden', 'true');

    const swatches = document.createElement('span');
    swatches.className = 'soksi-collection-rail__swatches';

    group.hexes.slice(0, 3).forEach((hex) => {
      const swatch = document.createElement('span');
      swatch.className = 'soksi-collection-rail__swatch';
      swatch.style.setProperty('--soksi-swatch-color', hex);
      swatch.title = hex;
      swatches.append(swatch);
    });

    if (group.hexes.length > 3) {
      const more = document.createElement('span');
      more.className = 'soksi-collection-rail__swatch-more';
      more.textContent = `+${group.hexes.length - 3}`;
      swatches.append(more);
    }

    const label = document.createElement('span');
    label.className = 'soksi-collection-rail__option-label';
    label.textContent = group.label;

    const count = document.createElement('span');
    count.className = 'soksi-collection-rail__option-count';
    count.textContent = String(group.count);

    button.append(marker);
    if (showSwatches && group.hexes.length > 0) button.append(swatches);
    button.append(label);
    button.append(count);

    button.addEventListener('click', () => {
      if (group.mode === 'client') {
        applyClientColorFilter(group.id);
      } else {
        applyColorFamilyFilter(paramName, groups, group.id);
      }
    });

    listItem.append(button);
    return listItem;
  };

  const renderColorPanel = (panel) => {
    const source = panel.querySelector('[data-soksi-color-source]');
    const list = panel.querySelector('[data-soksi-color-list]');
    if (!(list instanceof HTMLElement)) return;
    const paramName = source?.dataset.colorParamName;
    const colors = {
      Black: '#181818', White: '#FFFFFF', Grey: '#909090', Cream: '#F2E7CF',
      Brown: '#79503A', Red: '#CC242A', Orange: '#ED791E', Yellow: '#F2D443',
      Green: '#4D8549', Blue: '#3568B3', Purple: '#824994', Pink: '#E886AF',
      Nude: '#C99678', Multicolour: '#D66BA0',
    };
    const groups = Array.from(source?.querySelectorAll('[data-soksi-color-item]') ?? []).map((item) => {
      const value = item.dataset.colorValue;
      return {
        id: value,
        label: SOKSI_COLOR_FAMILY_LABELS[value.toLowerCase()] || item.dataset.colorLabel || value,
        count: Number(item.dataset.colorCount) || 0,
        active: item.dataset.colorActive === 'true',
        comboValues: [value], hexes: [colors[value] || '#909090'], mode: 'server',
      };
    }).sort((a, b) => Object.keys(colors).indexOf(a.id) - Object.keys(colors).indexOf(b.id));
    list.replaceChildren();
    groups.forEach((group) => {
      const item = buildGroupElement(group, paramName, groups, panel.dataset.soksiColorDisplay === 'swatches');
      const button = item.querySelector('button');
      button.setAttribute('aria-pressed', String(group.active));
      button.disabled = group.count === 0 && !group.active;
      if (group.id === 'Multicolour') {
        const swatch = item.querySelector('.soksi-collection-rail__swatch');
        if (swatch) swatch.style.background = 'conic-gradient(#CC242A, #F2D443, #4D8549, #3568B3, #824994, #CC242A)';
      }
      list.append(item);
    });
    const badge = panel.closest('.soksi-collection-rail__panel')?.querySelector('[data-soksi-color-badge]');
    const count = groups.filter((group) => group.active).length;
    if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
    const empty = panel.querySelector('[data-soksi-color-empty]');
    if (empty) empty.hidden = groups.length > 0;
    const fallback = panel.querySelector('[data-soksi-color-fallback-link]');
    if (fallback) fallback.hidden = true;
    panel.dataset.soksiColorMode = 'server';
    resetClientColorVisibility();
  };

  const initializeColorPanels = (root = document) => {
    root
      .querySelectorAll('[data-soksi-color-panel]')
      .forEach((panel) => renderColorPanel(panel));
  };

  const initializeSoksiCollectionEnhancements = () => {
    normalizeCollectionQueryParams();
    initializeCollectionPanelStatePersistence(document);

    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    initializeColorPanels(document);
    initializeCollectionViewButtons(document);
    applyCollectionViewVisibility(document);
    void ensureActiveCollectionViewHasVisibleResults(document);
    sanitizeNativeColorFacetLabels();
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeSoksiCollectionEnhancements();
    },
    { once: true }
  );

  if (!window.__soksiCollectionColorsObserverBound) {
    window.__soksiCollectionColorsObserverBound = true;

    const observer = new MutationObserver((mutations) => {
      const shouldInitialize = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof HTMLElement &&
            (node.matches('[data-soksi-color-panel], .product-grid__item, .facets__inputs, .facets-remove__pill, dialog')
              || node.querySelector('[data-soksi-color-panel], .product-grid__item, .facets__inputs, .facets-remove__pill, dialog'))
        )
      );

      if (shouldInitialize) {
        window.requestAnimationFrame(() => initializeSoksiCollectionEnhancements());
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('popstate', () => initializeSoksiCollectionEnhancements());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  (() => {
    const COLOR_ORDER = [
      'black',
      'white',
      'grey',
      'beige',
      'brown',
      'red',
      'orange',
      'yellow',
      'green',
      'blue',
      'purple',
      'pink',
      'other',
    ];

    const COLOR_KEYWORDS = {
      black: ['black', 'nero', 'noir', 'ebony', 'ebano', 'dark'],
      white: ['white', 'bianco', 'blanc', 'ivory', 'milk'],
      grey: ['grey', 'gray', 'grigio', 'gris', 'silver', 'argento'],
      beige: ['beige', 'nude', 'natural', 'naturel', 'ecru', 'cream', 'glace', 'cocoon'],
      brown: ['brown', 'marron', 'marrone', 'coffee', 'caffe', 'cocoa', 'taupe', 'cognac', 'bronze', 'cuivre'],
      red: ['red', 'rosso', 'rouge', 'scarlet', 'cherry', 'barolo', 'bordeaux', 'hibiscus', 'lipstick', 'geranio'],
      orange: ['orange', 'arancio', 'ochre', 'ocra', 'amber'],
      yellow: ['yellow', 'giallo', 'jaune', 'gold', 'oro', 'fluo'],
      green: ['green', 'verde', 'vert', 'forest', 'forrest', 'hunter', 'lime'],
      blue: ['blue', 'blu', 'navy', 'denim', 'jeans', 'cobalt', 'electric', 'turquoise', 'teal', 'aqua', 'azur'],
      purple: ['purple', 'violet', 'viola', 'lavender', 'lilac', 'plum', 'glycine'],
      pink: ['pink', 'rosa', 'rose', 'fuchsia', 'magenta', 'azalea', 'cyclamen'],
    };

    const HEX_PATTERN = /#[0-9a-f]{6}/gi;

    const normalizeText = (value = '') =>
      value
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const normalizeFacetValue = (value = '') =>
      value
        .toString()
        .trim()
        .toLowerCase();

    const extractHexes = (value = '') => {
      const matches = value.match(HEX_PATTERN);
      if (!matches) return [];
      return [...new Set(matches.map((match) => match.toUpperCase()))];
    };

    const hexToRgb = (hex) => {
      const normalized = hex.replace('#', '').trim();
      if (normalized.length !== 6) return null;

      const parsed = Number.parseInt(normalized, 16);
      if (Number.isNaN(parsed)) return null;

      return {
        r: (parsed >> 16) & 255,
        g: (parsed >> 8) & 255,
        b: parsed & 255,
      };
    };

    const rgbToHsl = (r, g, b) => {
      const red = r / 255;
      const green = g / 255;
      const blue = b / 255;
      const max = Math.max(red, green, blue);
      const min = Math.min(red, green, blue);
      const delta = max - min;
      let hue = 0;

      if (delta !== 0) {
        switch (max) {
          case red:
            hue = ((green - blue) / delta + (green < blue ? 6 : 0)) * 60;
            break;
          case green:
            hue = ((blue - red) / delta + 2) * 60;
            break;
          default:
            hue = ((red - green) / delta + 4) * 60;
            break;
        }
      }

      const lightness = (max + min) / 2;
      const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));

      return { h: hue, s: saturation, l: lightness };
    };

    const classifyColorFamily = (hex) => {
      const rgb = hexToRgb(`#${hex.toString().replace('#', '').trim().toUpperCase()}`);
      if (!rgb) return 'other';

      const { h, s, l } = rgbToHsl(rgb.r, rgb.g, rgb.b);
      const isHueBetween = (start, end) => (start <= end ? h >= start && h < end : h >= start || h < end);

      if (s <= 0.1) {
        if (l <= 0.15) return 'black';
        if (l >= 0.9) return 'white';
        return 'grey';
      }

      if (isHueBetween(25, 70) && s <= 0.35 && l >= 0.6 && l < 0.9) return 'beige';
      if (isHueBetween(15, 45) && s >= 0.18 && l <= 0.5) return 'brown';
      if (isHueBetween(345, 15)) return 'red';
      if (isHueBetween(15, 40)) return 'orange';
      if (isHueBetween(40, 70)) return 'yellow';
      if (isHueBetween(70, 170)) return 'green';
      if (isHueBetween(170, 255)) return 'blue';
      if (isHueBetween(255, 320)) return l > 0.63 ? 'pink' : 'purple';
      if (isHueBetween(320, 345)) return 'pink';

      return 'other';
    };

    const sortFamilyIds = (leftId, rightId) => {
      const leftIndex = COLOR_ORDER.indexOf(leftId);
      const rightIndex = COLOR_ORDER.indexOf(rightId);
      const normalizedLeft = leftIndex === -1 ? Number.MAX_SAFE_INTEGER : leftIndex;
      const normalizedRight = rightIndex === -1 ? Number.MAX_SAFE_INTEGER : rightIndex;

      return normalizedLeft - normalizedRight;
    };

    const sortGroups = (left, right) => {
      const familySort = sortFamilyIds(left.id, right.id);
      if (familySort !== 0) return familySort;
      if (left.count !== right.count) return right.count - left.count;

      return left.label.localeCompare(right.label);
    };

    const parseSelectedColorFamilies = (rawValue = '') =>
      new Set(rawValue.split(',').map((value) => normalizeFacetValue(value)).filter(Boolean));

    const serializeSelectedColorFamilies = (families) =>
      Array.from(families).filter(Boolean).sort(sortFamilyIds).join(',');

    const hasSetIntersection = (left, right) => {
      for (const value of left) {
        if (right.has(value)) return true;
      }

      return false;
    };

    const extractColorFamiliesFromText = (value = '') => {
      const normalized = ` ${normalizeText(value)} `;
      const families = new Set();

      Object.entries(COLOR_KEYWORDS).forEach(([family, keywords]) => {
        if (keywords.some((keyword) => normalized.includes(` ${keyword} `))) {
          families.add(family);
        }
      });

      if (families.size === 0) families.add('other');

      return Array.from(families);
    };

    const getFamilyLabels = (panel) => {
      const sourceNode =
        panel.closest('[data-soksi-color-family-labels]') || document.querySelector('[data-soksi-color-family-labels]');

      if (!(sourceNode instanceof HTMLElement)) return {};

      try {
        return JSON.parse(sourceNode.getAttribute('data-soksi-color-family-labels') || '{}');
      } catch {
        return {};
      }
    };

    const isGroupActive = (groupId, normalizedValues, selectedValues, selectedFamilies) => {
      if (selectedFamilies.size > 0) return selectedFamilies.has(groupId);
      if (selectedValues.size > 0) return hasSetIntersection(selectedValues, normalizedValues);

      return false;
    };

    const createGroupsFromEntries = (entries, labels, selectedValues = new Set(), selectedFamilies = new Set()) => {
      const groupsMap = new Map();
      const ensureGroup = (familyId) => {
        if (!groupsMap.has(familyId)) {
          groupsMap.set(familyId, {
            id: familyId,
            label: labels[familyId] || familyId,
            count: 0,
            comboValues: new Set(),
            hexes: new Set(),
          });
        }

        return groupsMap.get(familyId);
      };

      entries.forEach((entry) => {
        const families = entry.hexes.length
          ? [...new Set(entry.hexes.map((hex) => classifyColorFamily(hex)))]
          : extractColorFamiliesFromText(`${entry.label} ${entry.value}`);

        families.forEach((familyId) => {
          const group = ensureGroup(familyId);
          if (!group) return;

          group.count += entry.count;
          group.comboValues.add(entry.value);
          entry.hexes.forEach((hex) => group.hexes.add(hex));
        });
      });

      return Array.from(groupsMap.values())
        .map((group) => {
          const comboValues = Array.from(group.comboValues);
          const normalizedValues = new Set(comboValues.map((value) => normalizeFacetValue(value)).filter(Boolean));

          return {
            ...group,
            comboValues,
            hexes: Array.from(group.hexes),
            active: isGroupActive(group.id, normalizedValues, selectedValues, selectedFamilies),
            mode: 'server',
          };
        })
        .filter((group) => group.comboValues.length > 0 && group.id !== 'other')
        .sort(sortGroups);
    };

    const applyColorFamilyFilter = (paramName, groups, familyId = '') => {
      if (!paramName || !familyId) return;

      const url = new URL(window.location.href);
      url.searchParams.delete('page');

      const selectedFamilies = parseSelectedColorFamilies(url.searchParams.get('soksi_color') || '');

      if (selectedFamilies.size === 0) {
        groups.forEach((group) => {
          if (group.active) selectedFamilies.add(group.id);
        });
      }

      if (selectedFamilies.has(familyId)) {
        selectedFamilies.delete(familyId);
      } else {
        selectedFamilies.add(familyId);
      }

      const selectedValues = new Set();
      groups.forEach((group) => {
        if (!selectedFamilies.has(group.id)) return;

        group.comboValues.forEach((value) => {
          const normalizedValue = value.toString().trim();
          if (normalizedValue) selectedValues.add(normalizedValue);
        });
      });

      url.searchParams.delete(paramName);
      selectedValues.forEach((value) => url.searchParams.append(paramName, value));

      const serializedFamilies = serializeSelectedColorFamilies(selectedFamilies);
      if (serializedFamilies) {
        url.searchParams.set('soksi_color', serializedFamilies);
      } else {
        url.searchParams.delete('soksi_color');
      }

      window.location.assign(url.toString());
    };

    const buildGroupElement = (group, paramName, groups) => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className =
        'soksi-collection-rail__option soksi-collection-rail__option--color-group soksi-collection-rail__option--color-boxes';

      if (group.active) button.classList.add('is-active');

      const marker = document.createElement('span');
      marker.className = 'soksi-collection-rail__option-marker';
      marker.setAttribute('aria-hidden', 'true');

      const label = document.createElement('span');
      label.className = 'soksi-collection-rail__option-label';
      label.textContent = group.label;

      const count = document.createElement('span');
      count.className = 'soksi-collection-rail__option-count';
      count.textContent = String(group.count);

      button.append(marker, label, count);
      button.addEventListener('click', () => applyColorFamilyFilter(paramName, groups, group.id));

      item.append(button);
      return item;
    };

    const renderColorPanel = (panel) => {
      if (!(panel instanceof HTMLElement)) return;

      const source = panel.querySelector('[data-soksi-color-source]');
      const list = panel.querySelector('[data-soksi-color-list]');
      const emptyMessage = panel.querySelector('[data-soksi-color-empty]');
      const badge = panel.closest('.soksi-collection-rail__panel')?.querySelector('[data-soksi-color-badge]');

      if (!(source instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

      const paramName = source.dataset.colorParamName || '';
      const sourceItems = Array.from(source.querySelectorAll('[data-soksi-color-item]'));
      const url = new URL(window.location.href);
      const selectedValues = new Set(
        url.searchParams.getAll(paramName).map((value) => normalizeFacetValue(value)).filter(Boolean)
      );

      sourceItems.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.colorActive === 'true') {
          selectedValues.add(normalizeFacetValue(item.dataset.colorValue || ''));
        }
      });

      const selectedFamilies = parseSelectedColorFamilies(url.searchParams.get('soksi_color') || '');
      const signature = `${paramName}|${sourceItems
        .map((item) => `${item.dataset.colorValue}:${item.dataset.colorCount}:${item.dataset.colorActive}`)
        .join('|')}|${Array.from(selectedValues).sort().join('|')}|${serializeSelectedColorFamilies(selectedFamilies)}`;

      if (panel.dataset.soksiSearchColorSignature === signature) return;
      panel.dataset.soksiSearchColorSignature = signature;

      const labels = getFamilyLabels(panel);
      const entries = sourceItems
        .map((item) => {
          const value = item.dataset.colorValue || '';
          const label = (item.dataset.colorLabel || value).trim();
          const count = Number.parseInt(item.dataset.colorCount || '0', 10);
          const active = item.dataset.colorActive === 'true';

          return {
            value,
            label,
            count: Number.isFinite(count) ? count : 0,
            active,
            hexes: extractHexes(`${label};${value}`),
          };
        })
        .filter((entry) => entry.value !== '' && (entry.count > 0 || entry.active));

      const groups = createGroupsFromEntries(entries, labels, selectedValues, selectedFamilies);
      list.innerHTML = '';
      groups.forEach((group) => list.append(buildGroupElement(group, paramName, groups)));

      const activeGroupsCount = groups.filter((group) => group.active).length;
      if (badge instanceof HTMLElement) {
        badge.textContent = String(activeGroupsCount);
        badge.hidden = activeGroupsCount === 0;
      }

      if (emptyMessage instanceof HTMLElement) {
        emptyMessage.hidden = groups.length > 0;
      }
    };

    const initializeSearchColorPanels = (root = document) => {
      root.querySelectorAll('.soksi-search-results-template [data-soksi-color-panel]').forEach(renderColorPanel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSearchColorPanels(), { once: true });
    } else {
      initializeSearchColorPanels();
    }

    if (!window.__soksiSearchColorPanelsObserverBound) {
      window.__soksiSearchColorPanelsObserverBound = true;

      const observer = new MutationObserver((mutations) => {
        const shouldInitialize = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof HTMLElement &&
              (node.matches('.soksi-search-results-template [data-soksi-color-panel]')
                || node.querySelector('.soksi-search-results-template [data-soksi-color-panel]'))
          )
        );

        if (shouldInitialize) {
          window.requestAnimationFrame(() => initializeSearchColorPanels());
        }
      });

      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
